import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Approval Flow pages
export const ApprovalFlowListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/approval-flows/list')) as Promise<
      typeof import('@/pages/setting/approval-flows/list')
    >
);

export const ApprovalFlowEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/approval-flows/edit')) as Promise<
      typeof import('@/pages/setting/approval-flows/edit')
    >
);

export const ApprovalFlowCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/approval-flows/create')) as Promise<
      typeof import('@/pages/setting/approval-flows/create')
    >
);

// AF New User pages
export const AFNewUserListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/af-new-user/list')) as Promise<
      typeof import('@/pages/setting/af-new-user/list')
    >
);

export const AFNewUserEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/af-new-user/edit')) as Promise<
      typeof import('@/pages/setting/af-new-user/edit')
    >
);

export const AFNewUserCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/af-new-user/create')) as Promise<
      typeof import('@/pages/setting/af-new-user/create')
    >
);

// Billing Order pages
export const BillingOrderListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/billing-orders/list')) as Promise<
      typeof import('@/pages/setting/billing-orders/list')
    >
);

export const BillingOrderEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/billing-orders/edit')) as Promise<
      typeof import('@/pages/setting/billing-orders/edit')
    >
);

export const BillingOrderCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/billing-orders/create')) as Promise<
      typeof import('@/pages/setting/billing-orders/create')
    >
);
